/**
 * アプリエラー基底クラス
 */
export class BaseAppError {
  /**
   * コンストラクタ
   */
  constructor(private readonly message: string) {}

  /**
   * メッセージを取得する
   */
  public getMessage(): string {
    return this.message;
  }
}
